// import PropTypes from "prop-types";
// import React, { Component, useEffect } from "react";
// import { FaArrowRight, FaInfoCircle } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import '../../assets_/_login.css';
// import { useNavigate } from 'react-router-dom';

// import Cookies from "js-cookie";
// import { ApiUrl } from "../../config";

// export class Login extends Component {

//   constructor(props) {
//     super(props);
//     this.state = {
//       email: "",
//       password: "",
//       errorMessage: "",
//       loading: false,
//     };
//   }




//   ValidateForm = async () => {
//     let errorMessage = "";

//     if (!this.state.email) {
//       errorMessage = "Nom d'utilisateur obligatoire !";
//     } else if (!this.state.password) {
//       errorMessage = "Mot de passe obligatoire !";
//     }

//     if (errorMessage) {
//       this.setState({ errorMessage: errorMessage });
//       return;
//     } else {
//       this.setState({ errorMessage: "" });
//       return true;
//     }
//   };

//   handleInputChange = (event) => {
//     const { name, value } = event.target;
//     this.setState({ [name]: value });
//   };

//   handleLogin = async () => {
//     const { email, password } = this.state;

//     try {
//       const ValidateFormSuccess = await this.ValidateForm();
//       if (!ValidateFormSuccess) return;

//       this.setState({ loading: true }); // 👈 start loader

//       const response = await fetch(`${ApiUrl}login`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           email,
//           password,
//           user_type: "citoyen",
//         }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         this.setState({
//           errorMessage: data.error || "Une erreur s'est produite.",
//           loading: false, // 👈 stop loader
//         });
//         return;
//       }

//       const token = data.access_token;

//       Cookies.set("access_token", token, {
//         path: "/",
//         secure: true,
//         sameSite: "Strict",
//       });

//       window.location.href = "/mon-espace/mon-profile";
//     } catch (error) {
//       console.log(error);
//       this.setState({
//         errorMessage: "Une erreur réseau s'est produite.",
//         loading: false, // 👈 stop loader
//       });
//     }
//   };


//   render() {
//     const { email, password, errorMessage } = this.state;


//     return (
//       <div className="login-form">
//         <main className="d-flex align-items-center min-vh-100 py-3 py-md-0">
//           <div className="container">
//             <div className="card login-card">
//               <div className="row no-gutters">
//                 <div className="col-md-5  d-xs-none d-md-flex d-lg-flex d-sm-none">
//                   <img
//                     src="https://demo.bootstrapdash.com/login-template-free-2/assets/images/login.jpg"
//                     alt="login"
//                     className="login-card-img"
//                   />
//                   <p className="text-white font-weight-medium text-center flex-grow align-self-end footer-link text-small">
//                     Free{" "}
//                     <a
//                       href="https://www.bootstrapdash.com/"
//                       target="_blank"
//                       className="text-white"
//                     >
//                       Bootstrap dashboard templates
//                     </a>{" "}
//                     from Bootstrapdash
//                   </p>
//                 </div>
//                 <div className="col-md-7">
//                   <div className="card-body">
//                     <Link to="/" className="brand-wrapper">
//                       <img
//                         src="assets/img/hna-meak/Hna_m3ak_logo2.png"
//                         alt="logo"
//                         className="logo"
//                       />
//                     </Link>
//                     <p className="login-card-description mt-3">Se connecter à votre compte</p>
//                     {errorMessage && (
//                       <div className="alert alert-danger" role="alert">
//                         {errorMessage}
//                       </div>
//                     )}
//                     <form action="#!" className="login">
//                       <div className="form-group">
//                         <label className="sr-only">Nom d'utilisateur</label>
//                         <input
//                           type="email"
//                           name="email"
//                           id="email"
//                           className="form-control"
//                           placeholder="Nom d'utilisateur"
//                           value={email}
//                           onChange={this.handleInputChange}
//                         />
//                       </div>
//                       <div className="form-group mb-4">
//                         <label className="sr-only">Mot de passe</label>
//                         <input
//                           type="password"
//                           name="password"
//                           id="password"
//                           className="form-control"
//                           placeholder="**********"
//                           value={password}
//                           onChange={this.handleInputChange}
//                         />
//                       </div>
//                       <input
//                         name="login"
//                         id="login"
//                         className="btn btn-block login-btn mb-4"
//                         type="button"
//                         value={this.state.loading ? "Connexion..." : "Se connecter"}
//                         // value="Se connecter"
//                         onClick={this.handleLogin}
//                         disabled={this.state.loading}
//                       />
//                     </form>
//                     <a href="#!" className="forgot-password-link">
//                       Mot de passe oublié?
//                     </a>
//                     <p className="login-card-footer-text">
//                       Vous n'avez pas de compte ?
//                       <Link to="/register" className="ms-1 text-decoration-underline">
//                         S'enregistrer ici
//                       </Link> | <Link className=" text-decoration-underline" to="/demander-mes-identifiants">Demander mes identifiants</Link>
//                     </p>
//                     <nav className="login-card-footer-nav">
//                       <a href="#!">Terms of use.</a>
//                       <a href="#!">Privacy policy</a>
//                     </nav>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </main>
//       </div>
//     );
//   }
// }

// export default Login;
import PropTypes from "prop-types";
import React, { Component } from "react";
import { FaArrowRight, FaInfoCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import '../../assets_/_login.css';
import Cookies from "js-cookie";
import { ApiUrl } from "../../config";

export class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      errorMessage: "",
      loading: false,
      emailConfirmed: false, // 👈 new
    };
  }

  componentDidMount() {
    // 👇 Check for email_confirmed query param on mount
    const params = new URLSearchParams(window.location.search);
    if (params.get("email_confirmed") === "true") {
      this.setState({ emailConfirmed: true });
      // Clean the URL without reloading the page
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }

  ValidateForm = async () => {
    let errorMessage = "";
    if (!this.state.email) {
      errorMessage = "Nom d'utilisateur obligatoire !";
    } else if (!this.state.password) {
      errorMessage = "Mot de passe obligatoire !";
    }
    if (errorMessage) {
      this.setState({ errorMessage });
      return;
    } else {
      this.setState({ errorMessage: "" });
      return true;
    }
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleLogin = async () => {
    const { email, password } = this.state;
    try {
      const ValidateFormSuccess = await this.ValidateForm();
      if (!ValidateFormSuccess) return;

      this.setState({ loading: true });

      const response = await fetch(`${ApiUrl}login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
          user_type: "citoyen",
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        this.setState({
          errorMessage: data.error || "Une erreur s'est produite.",
          loading: false,
        });
        return;
      }

      const token = data.access_token;
      Cookies.set("access_token", token, {
        path: "/",
        secure: true,
        sameSite: "Strict",
      });

      window.location.href = "/mon-espace/mon-profile";
    } catch (error) {
      console.log(error);
      this.setState({
        errorMessage: "Une erreur réseau s'est produite.",
        loading: false,
      });
    }
  };

  render() {
    const { email, password, errorMessage, emailConfirmed } = this.state;

    return (
      <div className="login-form">
        <main className="d-flex align-items-center min-vh-100 py-3 py-md-0">
          <div className="container">
            <div className="card login-card">
              <div className="row no-gutters">
                <div className="col-md-5 d-xs-none d-md-flex d-lg-flex d-sm-none">
                  <img
                    src="https://demo.bootstrapdash.com/login-template-free-2/assets/images/login.jpg"
                    alt="login"
                    className="login-card-img"
                  />
                  <p className="text-white font-weight-medium text-center flex-grow align-self-end footer-link text-small">
                    Free{" "}
                    <a href="https://www.bootstrapdash.com/" target="_blank" className="text-white">
                      Bootstrap dashboard templates
                    </a>{" "}
                    from Bootstrapdash
                  </p>
                </div>
                <div className="col-md-7">
                  <div className="card-body">
                    <Link to="/" className="brand-wrapper">
                      <img
                        src="assets/img/hna-meak/Hna_m3ak_logo2.png"
                        alt="logo"
                        className="logo"
                      />
                    </Link>
                    <p className="login-card-description mt-3">Se connecter à votre compte</p>

                    {/* 👇 Email confirmed success banner */}
                    {emailConfirmed && (
                      <div className="alert alert-success d-flex align-items-center" role="alert">
                        <span className="me-2">✓</span>
                        Votre adresse e-mail a été confirmée. Connectez-vous avec vos nouveaux identifiants.
                      </div>
                    )}

                    {/* Error message */}
                    {errorMessage && (
                      <div className="alert alert-danger" role="alert">
                        {errorMessage}
                      </div>
                    )}

                    <form action="#!" className="login">
                      <div className="form-group">
                        <label className="sr-only">Nom d'utilisateur</label>
                        <input
                          type="email"
                          name="email"
                          id="email"
                          className="form-control"
                          placeholder="Nom d'utilisateur"
                          value={email}
                          onChange={this.handleInputChange}
                        />
                      </div>
                      <div className="form-group mb-4">
                        <label className="sr-only">Mot de passe</label>
                        <input
                          type="password"
                          name="password"
                          id="password"
                          className="form-control"
                          placeholder="**********"
                          value={password}
                          onChange={this.handleInputChange}
                        />
                      </div>
                      <input
                        name="login"
                        id="login"
                        className="btn btn-block login-btn mb-4"
                        type="button"
                        value={this.state.loading ? "Connexion..." : "Se connecter"}
                        onClick={this.handleLogin}
                        disabled={this.state.loading}
                      />
                    </form>
                    <a href="#!" className="forgot-password-link">
                      Mot de passe oublié?
                    </a>
                    <p className="login-card-footer-text">
                      Vous n'avez pas de compte ?
                      <Link to="/register" className="ms-1 text-decoration-underline">
                        S'enregistrer ici
                      </Link>{" "}|{" "}
                      <Link className="text-decoration-underline" to="/demander-mes-identifiants">
                        Demander mes identifiants
                      </Link>
                    </p>
                    <nav className="login-card-footer-nav">
                      <a href="#!">Terms of use.</a>
                      <a href="#!">Privacy policy</a>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default Login;